import React from 'react';
import Popup from '../common/popup/Popup';
import { Button } from 'react-bootstrap';
import '../../styles/components/user/SubscriptionPopup.css';

const SubscriptionPopup = ({ show, onClose, title, message }) => {
  if (!show) return null;
  return (
    <Popup
      title={title}
      onCancel={onClose}
      footer={<Button variant="primary" onClick={onClose}>OK</Button>}
    >
      <p>{message}</p>
    </Popup>
  );
};

export default SubscriptionPopup;
